import {NavLink, Outlet} from "react-router-dom"
export default function Promo(){
    return (
        <div>
            <h3>Promo <NavLink className={"btn btn-outline-default"}  to={"create"}>Créer promotion</NavLink> <NavLink className={"btn btn-outline-default"} to={"list"}>Liste promotions</NavLink></h3>
            <Outlet/>
        </div>
    )
}
